import ApiBase from 'app/services/api/entities/Base'

function* generateInitialDocuments(fiscalData) {
  return yield ApiBase.privatePost('/v1/contract_version/documents/generate_initials/', { data: fiscalData })
}

function* acceptContracts() {
  return yield ApiBase.privatePost('/v1/contracts/acceptance')
}

function* acceptDocument(documentName) {
  return yield ApiBase.privatePost(`/v1/contract_version/documents/${documentName}/agree/`, {})
}

function* checkFiscalPermissions() {
  return yield ApiBase.privateGet('/v1/contract_version/permissions/can_navigate/', {})
}

export default {
  generateInitialDocuments,
  acceptContracts,
  acceptDocument,
  checkFiscalPermissions,
}
